import { MenuItems } from '@menu-lib/components/AppLayout/MainMenu/menuItems';
import { MenuItemRegistry } from '@menu-lib/components/AppLayout/MainMenu/menuRegistry';
import { type LinkItem } from '@menu-lib/components/AppLayout/types';

MenuItemRegistry.register(MenuItems.Relaties, {
  isVisible: () => true,
  create: (): LinkItem => ({
    itemtype: 'link',
    menuItem: MenuItems.Relaties,
    title: 'Relaties',
    url: '/app/crm/relatiegegevens',
    iconclass: 'fas fa-network-wired',
    target: '_top',
  }),
});
